import { Gift } from "lucide-react";
import { cn } from "../lib/utils";

const RewardPhoto = ({
  src,
  alt = "Recompensa",
  icon: Icon = Gift,
  className,
  imageClassName,
  iconClassName,
}) => (
  <div
    className={cn(
      "relative flex min-w-0 items-center justify-center overflow-hidden rounded-xl bg-slate-100",
      className
    )}
  >
    {src ? (
      <img
        src={src}
        alt={alt}
        className={cn("h-full w-full object-cover", imageClassName)}
        loading="lazy"
      />
    ) : (
      <div className="flex h-full w-full items-center justify-center bg-accent/10">
        <Icon className={cn("h-8 w-8 text-accent", iconClassName)} />
      </div>
    )}
  </div>
);

export default RewardPhoto;
